export const ADD_EXPENSE = "ADD_EXPENSE";
export const REMOVE_EXPENSE = "REMOVE_EXPENSE";
export const EDIT_EXPENSE = "EDIT_EXPENSE";
export const SET_TEXT_FILTER = "SET_TEXT_FILTER";
export const SORT_BY_DATE = "SORT_BY_DATE";
export const SORT_BY_AMOUNT = "SORT_BY_AMOUNT";
export const SET_START_DATE = "SET_START_DATE";
export const SET_END_DATE = "SET_END_DATE";
export const SET_EXPENSES = "SET_EXPENSES";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
